module.exports = __webpack_public_path__ + "img/1.ef6574e3.gif";